export const STEM_CATEGORIES = [
  { key: "sciences", label: { en: "Sciences", fr: "Sciences" } },
  { key: "tech", label: { en: "Technology & Engineering", fr: "Technologie & Ingénierie" } },
  { key: "maths", label: { en: "Mathematics", fr: "Mathématiques" } },
  { key: "langues", label: { en: "Languages & Cultures", fr: "Langues & Cultures" } },
];

// All video IDs verified live via YouTube oEmbed.
export const STEM_VIDEOS = [
  { id: "D89ngRr4uZg", cat: "sciences", title: "Newton's three-body problem explained", author: "TED-Ed" },
  { id: "yWO-cvGETRQ", cat: "sciences", title: "Black holes & the information paradox", author: "Kurzgesagt" },
  { id: "H6u0VBqNBQ8", cat: "sciences", title: "The origin of consciousness", author: "Kurzgesagt" },
  { id: "tm6VSkm_ko8", cat: "sciences", title: "The largest river on Earth is in the sky", author: "TED-Ed" },
  { id: "kF4ju6j6aLE", cat: "tech", title: "String theory", author: "Brian Greene · TED-Ed" },
  { id: "bdwU_ZPk1cY", cat: "tech", title: "How we can detect pretty much anything", author: "TED-Ed" },
  { id: "aircAruvnKk", cat: "tech", title: "But what is a neural network?", author: "3Blue1Brown" },
  { id: "WUvTyaaNkzM", cat: "maths", title: "The essence of calculus", author: "3Blue1Brown" },
  { id: "fNk_zzaMoSs", cat: "maths", title: "Vectors — essence of linear algebra", author: "3Blue1Brown" },
  { id: "jbkSRLYSojo", cat: "maths", title: "200 countries, 200 years, 4 minutes", author: "Hans Rosling · BBC" },
  { id: "illApgaLgGA", cat: "langues", title: "How to acquire any language", author: "Poly-glot-a-lot" },
  { id: "5MgBikgcWnY", cat: "langues", title: "The first 20 hours — how to learn anything", author: "Josh Kaufman · TEDx" },
];

export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const ytEmbed = (id) => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
